@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

@form-element-width: 264px;

.order-scan-to-search-modal-body {
  padding: 16px 16px 64px;

  &:first-child {
    padding-top: 0;
  }
}

.toggler {
  align-items: center;
  border-radius: 4px;
  height: 32px;
  width: @form-element-width;
  padding: 12px 10px;
  font-size: 14px;
  border: 1px solid @order-scan-to-search-modal--toggler--border-color;
  background-color: @order-scan-to-search-modal--toggler--background-color;
}

.radio-form-element {
  padding-left: 23px; // 22px +1px for the radio's border
}

.order-status {
  padding: 8px 0;
}

.section-header {
  font-weight: @bold;
  font-size: 14px;
  line-height: 20px;
  height: 20px;
}

.footer {
  display: flex;
  padding-left: 16px;
  justify-content: space-between;
  align-items: center;
}
